import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import InnerBox from '@repo/ui/inner-box'

import useTranslate from '../../../../../lib/hooks/use-translate'
import { RadLight } from '../../../../../lib/types/models/rad/rad'
import LabelWithText from '../../../ols/label-with-text'

type Props = {
  rad: RadLight
}

const StaffPersonalSpaceRadSection = ({ rad }: Props) => {
  const { t } = useTranslate()

  return (
    <InnerBox className="rounded-lg p-3 bg-white-hover">
      <div className="grid grid-cols-4 gap-2 mobile:grid-cols-2">
        <LabelWithText
          label={t('staff.personal.space.my.journeys.details.tab.home.rad.date')}
          data={<Badge variant="secondaryRed" text={DateFormatter.DDMMYYYY(rad.date)} />}
        />
        <LabelWithText
          label={t('staff.personal.space.my.journeys.details.tab.home.rad.hour')}
          data={<Badge variant="secondaryRed" text={DateFormatter.getFormattedTime(rad.hours)} />}
        />
        <LabelWithText
          className="col-span-2"
          label={t('staff.personal.space.my.journeys.details.tab.home.rad.location')}
          data={`${rad.addressName} - ${rad.address1}, ${rad.zipCode} ${rad.city}`}
        />
      </div>
    </InnerBox>
  )
}

export default StaffPersonalSpaceRadSection
